module.exports = __webpack_public_path__ + "static/albens-cf9116ebb1e3f6d425b1a9b5c6e5be7e.png";